const AudioLib = require('@/services/audio-lib').default;

/**
 * Retrieves the appropriate message text based on the provided message ID.
 *
 * @param {string} messageId - The ID of the message to retrieve.
 * @returns {string} - The corresponding message text, or the raw messageId if not found.
 */
function showMessage (messageId) {
  console.info('SHOW MESSAGE: Received messageId:', messageId);

  // Check standard messages
  console.info('SHOW MESSAGE: Checking standard messages...');
  const message = Object.values(AudioLib.messages).find((m) => m.messageId === messageId || m.audioMessage === messageId);
  if (message) {
    console.info('SHOW MESSAGE: Found in standard messages:', message.message);
    return message.message;
  }

  // Check winner messages
  console.info('SHOW MESSAGE: Checking winner messages...');
  const winner = Object.values(AudioLib.winners).find((w) => w.messageId === messageId || w.audioMessage === messageId);
  if (winner) {
    console.info('SHOW MESSAGE: Found in winner messages:', winner.message);
    return winner.message;
  }

  // Fallback to the raw messageId if no match is found
  console.info('SHOW MESSAGE: No match found. Returning raw messageId:', messageId);
  return messageId;
}

module.exports = { showMessage };
